import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';

interface DownloadDatasetParams {
  modelId: number;
  datasetId: number;
  filename: string;
}

interface DatasetDownloadResponse {
  url: string;
}

export const useDownloadDatasetCustomModel = () => {
  const downloadDataset = async ({
    modelId,
    datasetId
  }: DownloadDatasetParams) => {
    // The endpoint returns a short-lived signed storage URL as JSON.
    // We deliberately do NOT fetch the file through Axios here: the API call
    // is cross-origin with an Authorization header (CORS preflight), and the
    // old endpoint answered with a 307 redirect to the blob host — browsers
    // refuse to follow a cross-origin redirect on a preflighted request, so
    // every download failed. Instead we read the URL and navigate the browser
    // straight to the blob (public SAS, no auth, no preflight). The filename
    // is enforced server-side via the signed Content-Disposition.
    const response = await Axios.get<DatasetDownloadResponse>(
      GET_URL(modelId.toString(), datasetId.toString()).customModelDataDownload
    );

    const { url } = response.data;

    const link = document.createElement('a');
    link.href = url;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return response.data;
  };

  return useMutation(downloadDataset);
};
